import * as React from "react";
const SvgFiRrLightbulbExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17.994 2.286A9.04 9.04 0 0 0 10.956.059C6.904.517 3.59 3.782 3.075 7.822c-.374 2.93.644 5.76 2.793 7.76C7.243 16.863 8 18.483 8 20.15v.16A3.694 3.694 0 0 0 11.69 24h.619a3.694 3.694 0 0 0 3.69-3.69v-.548c0-1.486.687-2.906 1.932-3.998A9 9 0 0 0 20.999 9a9.01 9.01 0 0 0-3.005-6.714M12.309 22h-.619c-.932 0-1.69-.758-1.69-1.69v-.161l-.002-.15H14v.31c0 .933-.759 1.69-1.69 1.69zm4.304-7.741c-1.177 1.032-1.998 2.34-2.376 3.74H9.689c-.42-1.43-1.258-2.764-2.458-3.88-1.671-1.556-2.463-3.76-2.171-6.043.399-3.138 2.974-5.673 6.121-6.03Q11.598 2 12.009 2c1.725 0 3.353.617 4.652 1.778a6.993 6.993 0 0 1-.048 10.481M11 10.999V6a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0m2.5 3.5a1.5 1.5 0 1 1-3.001 0 1.5 1.5 0 0 1 3.001 0"
    />
  </svg>
);
export default SvgFiRrLightbulbExclamation;
